import { createReducer, createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  fetchCurrentTenant: null,
  setCurrentTenant: ["tenant"],
});

export const TenantTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  siteFeeSetting: {
    agriculturalFee: 4,
    huntingFee: 15,
  },
  settings: {
    styles: {
      primaryColor: "#FBB943",
      secondaryColor: "#189EFF",
      buttonBackgroundColor: "#FBB943",
      buttonTextColor: "#000000",
      navbarBackgroundColor: "transparent",
      footerBackgroundColor: "#000000",
      primaryAccountBackgroundColor: "#FBFBFD",
    },
    SiteConfigs: {
      logo: "/assets/svgs/cashrent-logo.svg",
    },
  },
  isFetching: true,
};

/* ------------- Selectors ------------- */

export const TenantSelectors = {
  siteFeeSetting: (state) => state.tenant.siteFeeSetting,
};

/* ------------- Reducers ------------- */

export const setCurrentTenant = (state = INITIAL_STATE, action) => ({
  ...state,
  ...action.tenant,
  isFetching: false,
});

export const fetchCurrentTenant = (state = INITIAL_STATE) => ({
  ...state,
  isFetching: true,
});

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_CURRENT_TENANT]: setCurrentTenant,
  [Types.FETCH_CURRENT_TENANT]: fetchCurrentTenant,
});
